/* =========================================================================
   Penny Premium 3D — quick-view.js
   Opens a <dialog> and fills it with sections/quick-view.liquid fetched
   for the tapped product via the Section Rendering API
   (/products/{handle}?section_id=quick-view). The skeleton shows
   instantly; once content lands, product-form.js picks up the buy box via
   the shared shopify:section:load re-init. Escape/backdrop close comes
   free with the native dialog.
   ========================================================================= */

const dialog = document.querySelector('[data-quick-view-dialog]');

if (dialog) {
  const content = dialog.querySelector('[data-quick-view-content]');
  const skeleton = dialog.querySelector('[data-quick-view-skeleton]');
  let requestToken = 0;

  const open = async (url) => {
    const token = ++requestToken;
    content.replaceChildren();
    skeleton.removeAttribute('hidden');
    dialog.showModal();

    try {
      const separator = url.includes('?') ? '&' : '?';
      const res = await fetch(`${url}${separator}section_id=quick-view`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-quick-view-inner]');
      if (token !== requestToken || !dialog.open) return;
      if (!fresh) throw new Error('empty');

      skeleton.setAttribute('hidden', '');
      content.replaceChildren(fresh);
      document.dispatchEvent(new Event('shopify:section:load'));
    } catch (_) {
      if (token !== requestToken) return;
      // Fetch failed — just take the shopper to the product page
      window.location.href = url;
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-view-url]');
    if (trigger) {
      event.preventDefault();
      open(trigger.dataset.quickViewUrl);
      return;
    }
    if (event.target.closest('[data-quick-view-close]')) dialog.close();
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('close', () => {
    requestToken++;
    content.replaceChildren();
  });
}
